import React from "react";
import "./ResetCardLayout.css";

const ResetCardLayout = ({ children, style, className = "" }) => {
  return (
    <div style={style} className={`restCardLayout ${className}`}>
      {children}
    </div>
  );
};

export default ResetCardLayout;